import { FunctionComponent } from 'react';
import cn from 'classnames';
import { DraftConfigurationColor, PrintType } from '@/types';
import { isDigital } from '@/model/printType/isDigital';
import { EmbroideryDigital } from '@/model/printType/printTypes';
import { ColorWheel } from '@/components/common/icons/ColorWheel';
import './ColorPicker.scss';

interface ColorPickerProps {
  fill: string;
  colors: DraftConfigurationColor[];
  printType: PrintType;
  onChange: (color: DraftConfigurationColor) => void;
}

export const ColorPicker: FunctionComponent<ColorPickerProps> = ({
  fill,
  colors,
  printType,
  onChange,
}) =>
  isDigital(printType) && printType.id !== EmbroideryDigital ? (
    <label
      className={cn('print-color-button', {
        'print-color-button--selected': colors.every((color) => color.fill !== fill),
      })}
    >
      <span className="color-picker__wrapper print-color-wrapper">
        <ColorWheel className="color-picker__icon" />
        <input
          type="color"
          className="color-picker__input"
          name="color-picker"
          onChange={(event) => onChange({ fill: event.target.value })}
          value={fill}
        />
      </span>
    </label>
  ) : null;
